import {call, put, select, take, takeLatest} from 'redux-saga/effects';
import {
  completeProfileFailed,
  completeProfileSuccess,
} from '../actions/completeProfile.action';
import completeProfileApi from '../api/completeProfile.api';
import {
  COMPLETE_PROFILE_ERRORS,
  MARKETING_OPTIONS_STATUS,
  MARKETING_PERMISSION_IDS,
} from '../constants/constants';
import {
  COMPLETE_PROFILE_REQUESTED,
  GET_MARKETING_OPTIONS_FAILED,
  GET_MARKETING_OPTIONS_SUCCESS,
  UPDATE_MARKETING_OPTIONS_FAILED,
  UPDATE_MARKETING_OPTIONS_SUCCESS,
} from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';
import {getMarketingOptions, updateMarketingOptions} from '../actions';

function* completeProfile(action) {
  const getAuth = state => state.auth;
  const getLoginToken = state => state.loginToken;
  const loginToken = yield select(getLoginToken);
  const storeToken = yield select(getAuth);
  const headers = getBearerHeader(loginToken, storeToken);

  let requiredFields = [];
  const data = action.data;
  if (data.accountType === '2') {
    requiredFields = [
      'email',
      'readOnlyEmail',
      'postalCode',
      'streetAddress',
      'city',
      'accountType',
      'businessName',
      'businessCustomerType',
      'ageConfirmation',
      'termsAndConditionsAndPrivacyPolicyAccept',
      'whereDidYouHearAboutUs',
      'latitude',
      'longitude',
    ];
  } else {
    requiredFields = [
      'email',
      'readOnlyEmail',
      'postalCode',
      'streetAddress',
      'city',
      'accountType',
      'ageConfirmation',
      'termsAndConditionsAndPrivacyPolicyAccept',
      'whereDidYouHearAboutUs',
      'latitude',
      'longitude',
    ];
  }
  if (data.subscribeToMarketing) {
    yield put(getMarketingOptions(data.email));
    yield take([GET_MARKETING_OPTIONS_SUCCESS, GET_MARKETING_OPTIONS_FAILED]);
    yield put(
      updateMarketingOptions(
        MARKETING_PERMISSION_IDS.EMAIL,
        MARKETING_OPTIONS_STATUS.PENDING,
        data.email,
        true,
        data
      )
    );
    yield take([
      UPDATE_MARKETING_OPTIONS_SUCCESS,
      UPDATE_MARKETING_OPTIONS_FAILED,
    ]);
  }
  const errors = {};
  requiredFields.forEach(f => {
    if (!data[f]) {
      errors[f] = COMPLETE_PROFILE_ERRORS[f];
    }
  });
  if (Object.keys(errors).length) {
    yield put(completeProfileFailed(errors));
    return;
  }
  try {
    yield call(completeProfileApi.register, data, headers);
    yield put(completeProfileSuccess());
  } catch (e) {
    yield put(
      completeProfileFailed({
        general:
          (e.response && e.response.data && e.response.data.userMessage) ||
          e.message,
      })
    );
  }
}

export default function* completeProfileSaga() {
  yield takeLatest(COMPLETE_PROFILE_REQUESTED, completeProfile);
}
